/* global newrelic */

export const lbaiListener = () => {

  window.LIFE_CYCLE_EVENT_BUS.on('lbai.pageAction', ({ output }) => {
    const { actionName, actionObject } = output;
    if (actionName && actionObject) {
      window.newrelic.addPageAction(actionName, actionObject);
    }
  });

};
